import * as React from 'react';

const SvgList = (props) => (
  <svg
    viewBox='0 0 42 42'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    xmlSpace='preserve'
    {...props}
  >
    <path
      d='M12.456 3.917h-1.709c-5.125 0-6.833 3.058-6.833 6.833v25.625c0 1.418 1.606 2.22 2.733 1.367l2.922-2.187a1.721 1.721 0 0 1 2.255.17l2.835 2.854c.667.666 1.76.666 2.426 0l2.87-2.87a1.693 1.693 0 0 1 2.221-.154l2.921 2.187c1.128.837 2.734.034 2.734-1.367V7.333a3.427 3.427 0 0 1 3.416-3.416H12.456Zm7.26 20.073H12.03c-.7 0-1.282-.581-1.282-1.282 0-.7.581-1.28 1.282-1.28h7.687c.7 0 1.281.58 1.281 1.28 0 .7-.58 1.282-1.28 1.282Zm1.281-6.834h-10.25c-.7 0-1.28-.58-1.28-1.28 0-.701.58-1.282 1.28-1.282h10.25c.7 0 1.282.58 1.282 1.281 0 .7-.581 1.281-1.282 1.281Z'
      fill='currentColor'
    />
    <path
      d='M31.27 3.917v2.562a4.3 4.3 0 0 1 2.99 1.23c.82.837 1.263 1.914 1.263 3.041v4.134c0 1.264-.563 1.845-1.845 1.845h-3.28V7.351c0-.479.393-.872.872-.872V3.917Zm0 0a3.434 3.434 0 0 0-3.434 3.434v11.94h5.842c2.7 0 4.408-1.708 4.408-4.407V10.75c0-1.88-.769-3.587-1.999-4.835a6.909 6.909 0 0 0-4.817-1.998c.017 0 0 0 0 0Z'
      fill='currentColor'
    />
  </svg>
);

export default SvgList;
